import React from 'react';
import {
  Phone,
  LayoutDashboard,
  Truck,
  ClipboardList,
  Users,
  Shield,
  PanelLeftClose,
  PanelLeft,
} from 'lucide-react';
import NavItem from './NavItem';

export default function Sidebar({
  abaAtiva,
  setAbaAtiva,
  permissoes,
  collapsed,
  onToggleCollapse,
}) {
  const itens = [
    { key: 'novo', label: 'Novo Atendimento', icon: Phone, visible: permissoes.podeVerNovoAtendimento },
    { key: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, visible: permissoes.podeVerDashboard },
    { key: 'historico', label: 'Central', icon: ClipboardList, visible: permissoes.podeVerHistorico },
    { key: 'prestadores', label: 'Prestadores', icon: Truck, visible: permissoes.podeVerPrestadores },
    { key: 'usuarios', label: 'Usuários', icon: Users, visible: permissoes.podeVerUsuarios },
  ];

  return (
    <aside
      className={[
        'flex flex-col bg-surface border-r border-line/70 shrink-0',
        'transition-[width] duration-200 ease-snap',
        collapsed ? 'w-[68px]' : 'w-[240px]',
      ].join(' ')}
    >
      <div className={['flex items-center h-16 border-b border-line/70', collapsed ? 'justify-center px-2' : 'gap-2.5 px-4'].join(' ')}>
        <div className="flex items-center justify-center w-9 h-9 rounded-xl bg-brand-600 text-white shadow-sm shrink-0">
          <Shield size={18} strokeWidth={2.25} />
        </div>
        {!collapsed && (
          <div className="flex flex-col leading-tight min-w-0">
            <span className="text-sm font-semibold text-ink truncate">Defend</span>
            <span className="text-[11px] text-ink-subtle truncate">Mesa de Atendimento</span>
          </div>
        )}
      </div>

      <nav className="flex-1 flex flex-col gap-1 px-2.5 py-3">
        {itens
          .filter((i) => i.visible)
          .map((i) => (
            <NavItem
              key={i.key}
              icon={i.icon}
              label={i.label}
              active={abaAtiva === i.key}
              collapsed={collapsed}
              onClick={() => setAbaAtiva(i.key)}
            />
          ))}
      </nav>

      <div className="border-t border-line/70 p-2.5">
        <button
          onClick={onToggleCollapse}
          className="flex items-center justify-center gap-2 w-full rounded-xl py-2 text-ink-subtle hover:text-ink hover:bg-surface-subtle transition-colors"
          title={collapsed ? 'Expandir menu' : 'Recolher menu'}
        >
          {collapsed ? <PanelLeft size={16} /> : <PanelLeftClose size={16} />}
          {!collapsed && <span className="text-xs">Recolher</span>}
        </button>
      </div>
    </aside>
  );
}
